//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import productCategoryQuery from '~/apollo/queries/product/category-slug'
import productCategoriesQuery from '~/apollo/queries/product/all-categories'

export default {
  mixins: [seo],
  // _slug is optional (no sibling index.vue): /products/category/ would query
  // Strapi with slug undefined (400). 404 instead.
  validate ({ params }) {
    return typeof params.slug === 'string' && params.slug.length > 0
  },
  data () {
    return {
      fetched: false
    }
  },
  apollo: {
    productCategories: {
      prefetch: true,
      query: productCategoryQuery,
      variables () {
        return { slug: this.$route.params.slug }
      },
      // `data` is undefined when the query errored — guard or the SSR process dies.
      result ({ data, loading, networkStatus }) {
        if (data && data.productCategories && data.productCategories.length > 0) {
          this.seoTitle = data.productCategories[0].name
        }
        this.fetched = true
      },
      error (error) {
        console.error('[apollo] ' + this.$route.fullPath + ': ' + (error && error.message))
        this.fetched = true
      }
    },
    allProductCategories: {
      query: productCategoriesQuery,
      prefetch: true
    }
  },
  methods: {
    getColumnClass (smallTicketItem) {
      return smallTicketItem ? 'column is-one-quarter pt-0 pb-0' : 'column is-one-third pt-0 pb-0'
    },
    getTabletColumnClass (smallTicketItem) {
      return smallTicketItem ? 'column is-one-third pt-0 pb-0' : 'column is-half pt-0 pb-0'
    }
  },
  computed: {
    mixedTiles () {
      const ret = []
      const products = this.productCategories[0].products
      const showcases = this.productCategories[0].showcases
      for (let i = 0; i < products.length; i++) {
        showcases.forEach((showcase) => {
          if ((!showcase.indent && i === 0) || (showcase.indent === i)) {
            ret.push(showcase)
          }
        })
        ret.push(products[i])
      }
      showcases.forEach((showcase) => {
        if (showcase.indent >= products.length) {
          ret.push(showcase)
        }
      })
      return (ret.length > 0) ? ret : null
    }
  }
}

